import {
    SET_USERS,
    SET_EDIT_USER,
    SET_NEW_USER,
    SET_DELETE_USER,
    SET_DELETE_MULTI_USER,
    SET_LIST_USERS,
    SET_ONE_USER,
    RESET_ITEMS_USER,
    RESET_SELECTED_USER,
    RESET_LIST_USERS,
    SET_EDIT_PROFILE,
    SET_PASSWORD_CHANGE,
    SET_USER_TOKEN,
    RESET_USER_TOKEN,
} from "redux/constants/Users";

const initalAgreementState = {
    items: [],
    list: [],
    selected: {},
    loading: true,
};
const Users = (state = initalAgreementState, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_USERS: {
            return { ...state, items: payload, loading: false };
        }
        case SET_LIST_USERS: {
            return { ...state, list: payload };
        }
        case SET_ONE_USER: {
            return { ...state, selected: payload, loading: false };
        }
        case SET_NEW_USER: {
            // return { ...state, items: [payload, ...state.items] };
            return state;
        }

        case SET_EDIT_PROFILE: {
            let jwt = JSON.parse(localStorage.getItem("jwt"));
            jwt.user = payload;
            localStorage.setItem("jwt", JSON.stringify(jwt));
            return state;
        }
        case SET_PASSWORD_CHANGE: {
            return state;
        }

        case SET_EDIT_USER: {
            // let list = [...state.items];

            // try {
            //     let ind = list.findIndex((item) => item._id === payload._id);

            //     if (ind > -1) {
            //         list[ind] = payload;
            //     }
            // } catch (error) {}

            // return { ...state, items: list };
            return state;
        }

        case SET_DELETE_USER: {
            let list = state.items.filter((item) => item._id !== payload);
            return { ...state, items: list };
        }

        case SET_DELETE_MULTI_USER: {
            let arr = payload.split(",");
            let list = state.items.filter((item) => !arr.includes(item._id));

            return { ...state, items: list };
        }

        case SET_USER_TOKEN: {
            return { ...state, tokenResult: payload };
        }
        case RESET_USER_TOKEN: {
            delete state.tokenResult;
            return state;
        }
        case RESET_ITEMS_USER: {
            return { ...state, items: [], loading: true };
        }
        case RESET_LIST_USERS: {
            return { ...state, list: [] };
        }
        case RESET_SELECTED_USER: {
            return { ...state, selected: {}, loading: true };
        }

        default:
            return state;
    }
};

export default Users;
